import { errorClient } from "../../clients/ErrorClient";
export const handleError = (message) => {
    errorClient.reportError(message);
};
//# sourceMappingURL=handleError.js.map